import axios from 'axios';
import ApiConfig from './ApiConfig'
import ApiError from './ApiError'
import moment from 'moment';

class Api {

    constructor() {
        this.apiHost = process.env.VUE_APP_API_HOST;
        this.nrtmApiHost = process.env.VUE_APP_NRTM_API_HOST;
    }

    combineUrl(parent,child){ 

        if (!child){
            return parent;
        }

        let rootPath   = (parent.slice(-1) === "/") ? parent : parent + "/";
        let appendPath = (child.slice(0,1) === "/") ? child.slice(1) : child;
        return rootPath + appendPath;
    }



    _get(endpoint,apiOption){
        
        console.log("_get endpoint",endpoint);
        console.log("_get apiOption1",apiOption);

        let self = this;

        if (!apiOption) apiOption = {};

        apiOption = Object.assign( {} , ApiConfig.defaultApiOption  , apiOption );
        //apiOption = { ...ApiConfig.defaultApiOption , ...apiOption };
        console.log("_get apiOption2",apiOption);

        let options = {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            }
        };
     
        let authPromise = Promise.resolve(true);
        if (apiOption.authCheck){
            authPromise = this._checkAuth();
        }

        return authPromise
            .then(authorized => {
                if (!authorized) throw new UnauthorizedError();  //apiOption.onUnauthorized();
                return authorized;
            })
            .then(_ => {
                self._setAuthorization(options.headers);
                return axios.get(endpoint,options)
            })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                
                console.log(err);
                
                if (err instanceof UnauthorizedError) {
                    console.log("UnauthorizedErrorがcatchされました。");
                    self._callUnauthorizedHandler(apiOption);
                    err.handled = true;
                }

                //TODO:401エラーになった場合にもonUnauthorizedを実行する。
                if (err.response){
                    switch (err.response.status) {
                        case 401:                      
                            // Unauthorized  
                            self._callUnauthorizedHandler(apiOption);
                            err.handled = true;
                            break;
                        case 403:
                            // Forbidden
                            break;
                        default:
                            // 例外処理
                      }
                }
                
                console.log("例外の再生成を行います。");
                throw err;                
            });
     
        /*return axios.get(endpoint,options)
            .then(res => {
                //self.logger.debug(" get response",res)
                //console.log(res)
                if (res.status !== 200) {
                    throw new ApiError(res.status, res.statusText);
                }
                return res.data
            })
        */

    }

    _post(endpoint,data,apiOption){

        let self = this;

        if (!apiOption) apiOption = {};
        apiOption = Object.assign( {} , ApiConfig.defaultApiOption  , apiOption );                

        let options = {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                //"Access-Control-Allow-Origin": "*",
            }
        };

        

        let authPromise = Promise.resolve(true);
        if (apiOption.authCheck){
            authPromise = this._checkAuth();
        }


        return authPromise
            .then(authorized => {
                if (!authorized) throw new UnauthorizedError();  //apiOption.onUnauthorized();
                return authorized;
            })
            .then(_ => {
                self._setAuthorization(options.headers);
                return axios.post(endpoint,data,options)
            })
            .then(res => {
                //this.logger.debug(this.constructor.name + " post response",res)
                //console.log(res)
                if (res.status !== 200) {
                    throw new ApiError(res.status, res.statusText);
                }
                return res.data
            })
            .catch(err => {
                
                console.log(err);
                
                if (err instanceof UnauthorizedError) {
                    console.log("UnauthorizedErrorがcatchされました。",err);
                    self._callUnauthorizedHandler(apiOption);
                    err.handled = true;
                }

                //TODO:401エラーになった場合にもonUnauthorizedを実行する。
                if (err.response){
                    switch (err.response.status) {
                        case 401:                      
                            // Unauthorized  
                            self._callUnauthorizedHandler(apiOption);
                            err.handled = true;
                            break;
                        case 403:
                            // Forbidden
                            break;
                        default:
                            // 例外処理
                      }
                }
                
                console.log("例外の再生成を行います。");
                throw err;                
            });
   

    }

    _put(endpoint,data,apiOption){

        let self = this;

        if (!apiOption) apiOption = {};
        apiOption = Object.assign( {} , ApiConfig.defaultApiOption  , apiOption );       

        let options = {
            headers: {
                "Content-Type": "application/json; charset=utf-8",                
            }
        };


        let authPromise = Promise.resolve(true);
        if (apiOption.authCheck){
            authPromise = this._checkAuth();
        }

        return authPromise
            .then(authorized => {
                if (!authorized) throw new UnauthorizedError();
                return authorized;
            })
            .then(_ => {
                self._setAuthorization(options.headers)
                return axios.put(endpoint,data,options)
            })
            .then(res => {
                //console.log("_put response",res)
                if (res.status !== 200) {
                    throw new ApiError(res.status, res.statusText);
                }
                return res.data
            })
            .catch(err => {
                console.log(err)

                if (err instanceof UnauthorizedError) {
                    console.log("UnauthorizedErrorがcatchされました。",err);
                    self._callUnauthorizedHandler(apiOption);
                    err.handled = true;
                }

                //TODO:401エラーになった場合にもonUnauthorizedを実行する。
                if (err.response){
                    switch (err.response.status) {
                        case 401:                      
                            // Unauthorized  
                            self._callUnauthorizedHandler(apiOption);
                            err.handled = true;
                            break;
                        case 403:
                            // Forbidden
                            break;
                        default:
                            // 例外処理
                      }
                }

                //let res = error.response;
                //throw new ApiError(res.status, res.statusText,error.response);

                console.log("例外の再生成を行います。");
                throw err;
            });
    }

    _upload(endpoint,file,data,onProgress,apiOption){

        let self = this;

        if (!apiOption) apiOption = {};
        apiOption = Object.assign( {} , ApiConfig.defaultApiOption  , apiOption );   

        //console.log("FileAPI.uploadFile");
        //console.log(file);

        let formData = new FormData();
        formData.append('file', file);
        formData.append('type', file.type);


        let options = {
            headers: {
                "Content-Type": "multipart/form-data",
                //...formData.getHeaders()
            },
            onUploadProgress(progressEvent) {
                let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total );
                if (onProgress) onProgress(percentCompleted);
                return percentCompleted;
            },
        };

        let authPromise = Promise.resolve(true);
        if (apiOption.authCheck){
            authPromise = this._checkAuth();
        }

        self._setAuthorization(options.headers);

        return authPromise
            .then(authorized => {
                if (!authorized) throw new UnauthorizedError();
                return authorized;
            })
            .then(_ => {
                self._setAuthorization(options.headers)
                return axios.post(endpoint,formData,options)
            })
            .then(res => {
                if (res.status !== 200) {
                    throw new ApiError(res.status, res.statusText);
                }
                return res.data
            })
            .catch(err => {
                console.log(err)

                if (err instanceof UnauthorizedError) {
                    console.log("UnauthorizedErrorがcatchされました。",err);
                    self._callUnauthorizedHandler(apiOption);
                    err.handled = true;
                }

                //TODO:401エラーになった場合にもonUnauthorizedを実行する。
                if (err.response){
                    switch (err.response.status) {
                        case 401:                      
                            // Unauthorized  
                            self._callUnauthorizedHandler(apiOption);
                            err.handled = true;
                            break;
                        case 403:
                            // Forbidden
                            break;
                        default:
                            // 例外処理
                      }
                }

                //let res = error.response;
                //throw new ApiError(res.status, res.statusText,error.response);

                console.log("例外の再生成を行います。");
                throw err;
            });

    }


    _setAuthorization(headers){        
        if (ApiConfig.authCode){
            //      Authorization
            headers.Authorization = "Bearer " + ApiConfig.authCode;
            //params.headers.Authorization = ApiConfig.authCode;
            //axios.defaults.headers.common['Authorization'] = data.idToken;
        } else {
            console.log("authCodeが設定されていません。");
        }
    }

    _callUnauthorizedHandler(apiOption){
        if (apiOption.onUnauthorized) {
            apiOption.onUnauthorized();
            return true;
        }
        return false;
    }


    /**
     * 認証状態を確認、可能であれば再取得する
     * @returns 認証結果 true:認証済 false:認証されてない
     */
    _checkAuth(){

        let companyCd = "mykk";
       

        let tokenSet = ApiConfig.getAuthTokenSet();
        if (!tokenSet || !tokenSet.refreshToken){ // refreshTokenが無い場合もダメってことにする            
            return Promise.resolve(false);
        }
        
        // step1.AccessTokenが有効ならAccessTokenでの認証を行う        
        if (tokenSet.accessToken && tokenSet.accessToken.jwtToken){
            let thTime = moment().add(5,"minutes"); // 閾値 5分後の時間で判定する
            let expierAt = moment(tokenSet.accessToken.expiresAt);
            if (expierAt.isAfter(thTime)){
                // AccessTokenでの認証を行う。多分大丈夫。
                return Promise.resolve(true);
            }
        }
        

        // step2.RefreshTokenでの再認証を試みる 
        let refreshToken = tokenSet.refreshToken.token;
        let userId = tokenSet.refreshToken.userId;
        if (refreshToken && userId){
            let postData = {
                userId: userId,
                refreshToken: refreshToken
            };
    
            let refreshEndpointPath = "/auth/" + companyCd + "/refresh";
            let refreshEndpoint =  this.combineUrl(this.nrtmApiHost,refreshEndpointPath);
            
            let opt = {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",                    
                }
            };

            return axios.post(refreshEndpoint,postData,opt)
                .then(res => {
                    let data = res.data;
                    console.log("再認証に成功しました。");
                    // 新しいTokenを再設定する
                    ApiConfig.setAuthTokenSet(data);                    
                    return true;
                })
                .catch(e => {
                    // どちらもダメだったらローカルセッションを無効にしておく
                    //window.sessionStorage.clear();
                    //window.localStorage.clear();
                    ApiConfig.clear();
                    return false;
                });

        }
        else {
            return Promise.resolve(false);
        }

    }

    _getAccessToken(){
        return ApiConfig.authCode;
    }

    _jumpToLogin(){

        //TODO:今がルート or ログイン画面の表示だったら下記は処理したらダメ

        window.location.href = "/"; // ルートに遷移すればログイン画面が表示されるはず。。
    }
  

}

export class UnauthorizedError extends Error {
    constructor(message) {
        super(message);
        this.description = message;
        this.name = 'Unauthorized';
        this.status = 401;
      }
}

export default Api;